// Complete bilingual translation dictionary for AstaEnterprise (ID / EN)
export const translations = {
  id: {
    meta: {
      title: "Software Toko Emas & Aplikasi POS Perhiasan Terbaik | AstaEnterprise",
      description: "Software toko emas modern untuk kelola stok kadar emas, transaksi buyback, cetak barcode tag, dan integrasi timbangan digital. Coba demo gratis AstaEnterprise.",
      keywords: "software toko emas, aplikasi kasir toko emas, program toko emas, pos perhiasan, sistem akuntansi toko emas, aplikasi kasir emas, barcode perhiasan, buyback emas, asta enterprise",
    },
    nav: {
      features: "Fitur Unggulan",
      howItWorks: "Cara Kerja",
      gallery: "Galeri Modul",
      pricing: "Harga",
      faq: "FAQ",
      ecosystem: "Ekosistem",
      whatsapp: "WhatsApp",
      requestDemo: "Request Demo Gratis",
      erp: {
        title: "ERP Software Emas",
        desc: "Sistem POS & inventori lengkap",
      },
      academy: {
        title: "Gold Business Academy",
        desc: "Edukasi & workshop owner emas",
      },
      community: {
        title: "Komunitas Pengusaha Emas",
        desc: "Jaringan & relasi pengusaha emas",
      },
      contact: "Kontak Kami",
    },
    hero: {
      badge: "Platform ERP & POS Toko Emas #1 di Indonesia",
      titleStart: "Sistem Bisnis & POS Modern untuk ",
      titleHighlight: "Toko Emas & Berlian",
      subheadline: "Kelola stok per kadar & gramasi desimal, update harga emas massal, cetak barcode label, dan nota surat emas resmi dalam satu ekosistem terintegrasi.",
      ctaPrimary: "Coba Demo Gratis",
      ctaSecondary: "Konsultasi WhatsApp",
      stats: {
        users: "200+ Toko Pengguna",
        accuracy: "99.9% Akurasi Gramasi",
        sync: "1 Detik Sinkronisasi",
        startingPrice: "Mulai Rp 499rb/bln",
      },
    },
    painPoints: {
      title: "Tantangan Nyata Pembukuan Toko Emas",
      subtitle: "Pengelolaan manual dan spreadsheet terpisah menyita waktu, rawan selisih gramasi, dan membuka celah kecurangan.",
      solutionTag: "Solusi: Sistem Terotomatisasi",
      items: [
        {
          title: "Pencatatan Manual Rawan Selisih Gramasi",
          desc: "Mencatat stok di buku atau spreadsheet terpisah sering memicu salah hitung gramasi, koma desimal hilang, dan selisih fisik saat tutup toko.",
        },
        {
          title: "Lambat Menyesuaikan Fluktuasi Harga",
          desc: "Saat harga emas dunia bergerak cepat, staf kasir kesulitan menghitung manual harga jual dan buyback untuk ratusan perhiasan.",
        },
        {
          title: "Tulis Tangan Surat Emas & Label",
          desc: "Antrean kasir menumpuk karena nota atau surat emas ditulis tangan satu per satu tanpa barcode scanner, berisiko dipalsukan pihak luar.",
        },
        {
          title: "Risiko Kehilangan Stok Tanpa Audit Log",
          desc: "Sulit memantau siapa staf yang memproses diskon, mengubah harga dasar, atau memindahkan barang antar brankas dan etalase.",
        },
      ],
    },
    features: {
      title: "Modul Lengkap Khusus Toko Emas Indonesia",
      subtitle: "Dibangun dengan pemahaman mendalam atas kadar karatase, gramasi, margin spread, dan faktur perhiasan.",
      items: [
        {
          id: "dashboard",
          badge: "Dashboard Eksekutif",
          title: "Pantau Omset Harian, Nilai Emas Etalase, & Arus Kas Real-Time",
          desc: "Visibilitas menyeluruh atas perputaran uang dan gramasi perhiasan toko tanpa menunggu rekap tutup kasir manual.",
          highlights: [
            "Ringkasan omset penjualan harian, mingguan, & bulanan otomatis",
            "Tracking total berat gramasi emas aktif di etalase & brankas",
            "Grafik pergerakan harga emas 24K dan margin keuntungan toko",
            "Monitoring transaksi buyback harian dan sisa kas riil",
          ],
          image: "/assets/screenshots/dashboard.webp",
          url: "app.astaenterprise.id/dashboard",
          imageBadge: "Real-time KPI",
        },
        {
          id: "inventory",
          badge: "Manajemen Stok",
          title: "Kontrol Stok Akurat hingga Desimal Gram & Karatase Lengkap",
          desc: "Kelola ribuan perhiasan dengan rincian kadar (16K, 17K, 18K, 22K, 24K), berat bersih, berat kotor, foto produk, dan lokasi fisik.",
          highlights: [
            "Pencatatan detail berat kotor, berat bersih, dan kadar karatase",
            "Filter cepat lokasi perhiasan (Etalase Utama, Brankas, Gudang)",
            "Notifikasi otomatis saat stok perhiasan populer mulai menipis",
            "Pencarian instan berdasarkan SKU, barcode, atau nama model",
          ],
          image: "/assets/screenshots/inventory.webp",
          url: "app.astaenterprise.id/inventori",
          imageBadge: "Kadar 6K - 24K",
        },
        {
          id: "gold-price",
          badge: "Update Harga Emas",
          title: "Update Harga Dasar Sekali Klik, Otomatis Mengubah Ribuan Produk Etalase",
          desc: "Saat harga pasar berfluktuasi, tidak perlu mengubah label harga satu per satu. Sistem langsung merefleksikan harga jual dan buyback ke seluruh kasir.",
          highlights: [
            "Pengaturan harga jual dan buyback per kadar (6K - 24K)",
            "Formula margin & spread otomatis sesuai strategi toko",
            "Sinkronisasi instan ke seluruh komputer kasir cabang dalam 1 detik",
            "Cegah kerugian akibat kasir menjual dengan harga emas kemarin",
          ],
          image: "/assets/screenshots/gold-price.webp",
          url: "app.astaenterprise.id/harga-emas",
          imageBadge: "1-Click Update",
        },
        {
          id: "pos",
          badge: "POS Kasir",
          title: "Transaksi Kasir Cepat & Akurat Tanpa Perlu Hitung Manual",
          desc: "Cukup scan barcode perhiasan, sistem langsung menghitung total harga berdasarkan berat gram riil, kadar, ongkos pembuatan, dan diskon promo.",
          highlights: [
            "Integrasi barcode scanner jewelry tag untuk proses kasir instan",
            "Kalkulasi otomatis total harga tanpa kalkulator fisik terpisah",
            "Mendukung multi-pembayaran: Tunai, QRIS, Transfer Bank, & EDC",
            "Cetak surat emas / faktur garansi resmi langsung saat transaksi selesai",
          ],
          image: "/assets/screenshots/pos.webp",
          url: "app.astaenterprise.id/pos",
          imageBadge: "Barcode Ready",
        },
      ],
    },
    howItWorks: {
      title: "4 Langkah Mudah Implementasi di Toko Anda",
      subtitle: "Tim spesialis AstaEnterprise mendampingi toko Anda dari migrasi data hingga kasir siap bertransaksi.",
      steps: [
        {
          num: "01",
          title: "Setup Profil & Cabang Toko",
          desc: "Konfigurasi identitas toko, cabang, format surat emas resmi, logo, dan margin harga per kadar emas.",
        },
        {
          num: "02",
          title: "Import Stok & Cetak Barcode",
          desc: "Upload data perhiasan dari Excel lama, lalu cetak label barcode thermal perhiasan ukuran standar 40x30mm.",
        },
        {
          num: "03",
          title: "Sinkronisasi Harga Harian",
          desc: "Tentukan harga dasar per kadar. Seluruh etalase dan kasir cabang langsung terupdate serentak dalam 1 detik.",
        },
        {
          num: "04",
          title: "Mulai Transaksi & Pantau Real-Time",
          desc: "Kasir melayani transaksi cepat dengan barcode scanner, sementara Owner memantau omset dari mana saja.",
        },
      ],
    },
    gallery: {
      title: "Eksplorasi Seluruh Modul ERP",
      subtitle: "Pilih modul di bawah ini untuk melihat tampilan asli antarmuka aplikasi AstaEnterprise.",
      ctaDemo: "Coba Modul Ini di Demo",
      liveBadge: "Live Capture",
      modules: [
        {
          id: "dashboard",
          title: "Dashboard & Omset",
          badge: "Ringkasan Eksekutif",
          image: "/assets/screenshots/dashboard.webp",
          url: "app.astaenterprise.id/dashboard",
          desc: "Pantau omset penjualan harian, tren harga emas 24K, total gramasi emas aktif, dan arus kas dalam satu tampilan terpadu.",
          highlights: [
            "Grafik omset harian, mingguan, & bulanan otomatis",
            "Rekapitulasi gramasi emas aktif di etalase dan brankas",
            "Monitoring transaksi buyback & kas masuk real-time",
          ],
        },
        {
          id: "inventory",
          title: "Stok & Kadar Emas",
          badge: "Kadar 6K - 24K",
          image: "/assets/screenshots/inventory.webp",
          url: "app.astaenterprise.id/inventori",
          desc: "Manajemen perhiasan presisi dengan pencatatan berat bersih, berat kotor, kadar karatase, foto perhiasan, dan lokasi etalase.",
          highlights: [
            "Pemisahan berat kotor, berat bersih, & kadar perhiasan",
            "Klasifikasi Cincin, Kalung, Gelang, Anting, & Logam Mulia",
            "Peringatan dini otomatis saat stok perhiasan menipis",
          ],
        },
        {
          id: "pos",
          title: "Kasir POS & Barcode",
          badge: "Kasir Cepat",
          image: "/assets/screenshots/pos.webp",
          url: "app.astaenterprise.id/pos",
          desc: "Transaksi kasir kilat dengan scan barcode jewelry tag. Hitung otomatis ongkos bikin, kadar emas, dan multi-pembayaran.",
          highlights: [
            "Scan barcode label perhiasan tanpa salah ketik manual",
            "Kalkulasi diskon, ongkos bikin, dan pajak otomatis",
            "Mendukung pembayaran Tunai, QRIS, Transfer, & EDC",
          ],
        },
        {
          id: "gold-price",
          title: "Update Harga Emas",
          badge: "1-Click Sync",
          image: "/assets/screenshots/gold-price.webp",
          url: "app.astaenterprise.id/harga-emas",
          desc: "Ubah harga dasar emas sekali klik. Seluruh harga jual dan buyback di setiap kasir cabang langsung tersinkronisasi dalam 1 detik.",
          highlights: [
            "Setting harga jual & buyback per kadar (6K - 24K)",
            "Formula margin & spread otomatis sesuai fluktuasi pasar",
            "Cegah kerugian akibat kasir menjual dengan harga kemarin",
          ],
        },
        {
          id: "buyback",
          title: "Buyback Emas",
          badge: "Transparan",
          image: "/assets/screenshots/buyback.webp",
          url: "app.astaenterprise.id/buyback",
          desc: "Layanan beli kembali (buyback) perhiasan pelanggan dengan verifikasi surat emas lama dan kalkulasi potongan susut otomatis.",
          highlights: [
            "Validasi nomor seri dan keaslian surat emas lama",
            "Hitung otomatis potongan susut gramasi & batu permata",
            "Cetak tanda terima buyback resmi dan riwayat pelanggan",
          ],
        },
        {
          id: "reports",
          title: "Laporan Keuangan",
          badge: "Laba Rugi & Mutasi",
          image: "/assets/screenshots/reports.webp",
          url: "app.astaenterprise.id/laporan",
          desc: "Laporan bisnis komprehensif mulai dari laba kotor, rekap kasir harian, hingga neraca mutasi fisik gramasi emas keluar-masuk.",
          highlights: [
            "Laporan mutasi fisik gram emas (masuk, keluar, saldo)",
            "Analisis laba kotor & performa penjualan per kasir",
            "Export laporan satu klik ke format Excel dan PDF",
          ],
        },
        {
          id: "multi-branch",
          title: "Multi-Cabang",
          badge: "Pusat Kontrol",
          image: "/assets/screenshots/multi-branch.webp",
          url: "app.astaenterprise.id/multi-cabang",
          desc: "Awasi performa banyak toko emas dan kelola transfer stok antar cabang secara terpusat dari satu dashboard.",
          highlights: [
            "Komparasi omset dan performa antar cabang toko",
            "Mutasi dan transfer stok antar toko dengan surat jalan",
            "Konsolidasi laporan keuangan seluruh cabang",
          ],
        },
        {
          id: "employees",
          title: "Hak Akses & Keamanan",
          badge: "Audit Trail",
          image: "/assets/screenshots/employees.webp",
          url: "app.astaenterprise.id/karyawan",
          desc: "Batasi hak akses pengguna berdasarkan peran (Owner, Admin, Kasir, Inventory) serta rekam seluruh riwayat aktivitas.",
          highlights: [
            "Kasir tidak dapat mengubah harga emas tanpa otorisasi",
            "Audit trail mencatat setiap mutasi, edit harga, & diskon",
            "Proteksi penuh terhadap risiko fraud internal toko",
          ],
        },
      ],
    },
    testimonials: {
      title: "Dipercaya Lebih dari 200+ Toko Emas",
      subtitle: "Cerita nyata para pemilik toko emas yang telah berhasil mengoptimalkan operasional dan omset toko mereka.",
      items: [
        {
          quote: "Dulu setiap pagi kami repot hitung ulang harga ribuan perhiasan saat harga emas naik. Dengan AstaEnterprise, cukup 1 menit update harga dasar, semua kasir di 3 cabang langsung tersinkronisasi. Rekap gramasi harian sekarang 100% klop.",
          name: "H. Hendra Wijaya",
          role: "Pemilik Toko Mas Sejahtera",
          location: "Surabaya",
          avatar: "HW",
        },
        {
          quote: "Fitur cetak surat emas ber-QR Code dan barcode label perhiasannya sangat rapi dan profesional. Pelanggan merasa jauh lebih percaya, dan kasir kami tidak pernah salah input berat atau kadar lagi.",
          name: "Ibu Ratna Dewi",
          role: "Owner Dewi Jewelry Gallery",
          location: "Bandung",
          avatar: "RD",
        },
        {
          quote: "Sebagai pengrajin yang juga punya toko retail, kontrol stok bahan mentah dan perhiasan jadi sangat krusial. AstaEnterprise memberikan kontrol penuh dari emas masuk leburan sampai laku terjual.",
          name: "Bpk. Agus Salim",
          role: "Founder Berkah Mulia Gold",
          location: "Yogyakarta",
          avatar: "AS",
        },
      ],
    },
    pricing: {
      title: "Pilihan Paket Sesuai Skala Toko Emas",
      subtitle: "Tanpa biaya tersembunyi. Sudah termasuk update sistem gratis dan backup cloud otomatis.",
      periodMonth: "/ bulan",
      popularBadge: "Paling Populer",
      tiers: [
        {
          name: "Starter",
          tagline: "Ideal untuk toko emas mandiri yang ingin beralih ke pembukuan & POS digital.",
          price: "Rp 499.000",
          period: "/ bulan",
          featured: false,
          features: [
            "1 Cabang Toko Emas",
            "Hingga 3 Akun Kasir & Staf",
            "POS Kasir & Barcode Scanner",
            "Manajemen Stok per Kadar (6K - 24K)",
            "Update Harga Emas Massal",
            "Cetak Label Barcode & Surat Emas",
            "Laporan Penjualan Harian",
            "Support WhatsApp & Panduan Video",
          ],
          ctaText: "Pilih Paket Starter",
        },
        {
          name: "Professional",
          tagline: "Paling populer untuk toko emas berkembang dengan multi-kasir dan transaksi tinggi.",
          price: "Rp 1.199.000",
          period: "/ bulan",
          featured: true,
          badge: "Paling Populer",
          features: [
            "Hingga 3 Cabang Toko Emas",
            "Unlimited Akun Kasir & Staf",
            "Semua Fitur Paket Starter",
            "Modul Buyback Emas Transparan",
            "Laporan Mutasi Gramasi & Laba Rugi",
            "Audit Trail & Log Keamanan Lengkap",
            "Transfer Stok Antar Cabang",
            "Migrasi Data Excel Dibantu Tim Ahli",
            "Prioritas Customer Support 7 Hari",
          ],
          ctaText: "Mulai Uji Coba Gratis",
        },
        {
          name: "Enterprise",
          tagline: "Solusi lengkap untuk jaringan toko emas besar, pengrajin, dan distributor.",
          price: "Kustom",
          period: "",
          featured: false,
          features: [
            "Unlimited Cabang & Gudang Terpusat",
            "Unlimited Akun & Otorisasi Bertingkat",
            "Integrasi Timbangan Digital Presisi",
            "Custom Format Surat Emas & Nota Ber-QR",
            "Dedicated Cloud Database Server",
            "Pelatihan Staf Onsite di Toko",
            "Dedicated Account Manager 24/7",
            "SLA Keandalan Sistem 99.9%",
          ],
          ctaText: "Konsultasi Kebutuhan",
        },
      ],
      banner: {
        badge: "Jadwalkan Demo & Konsultasi Langsung",
        title: "Siap Meningkatkan Profit & Efisiensi Toko Emas Anda?",
        desc: "Konsultasikan kebutuhan toko Anda dengan tim spesialis kami. Kami siap mendemonstrasikan sistem secara langsung dan memandu migrasi data.",
        cta: "Chat WhatsApp Tim Ahli",
        sub: "Respon cepat pada jam kerja toko emas",
      },
    },
    faq: {
      title: "Pertanyaan yang Sering Diajukan",
      subtitle: "Informasi lengkap seputar keamanan data, migrasi, dan kompatibilitas hardware.",
      items: [
        {
          q: "Apakah data stok dan transaksi toko emas saya aman di cloud?",
          a: "Sangat aman. AstaEnterprise menggunakan enkripsi SSL 256-bit standar perbankan dengan infrastruktur cloud bersertifikasi ISO. Kami melakukan backup otomatis setiap hari untuk memastikan data inventaris dan nilai emas Anda terlindungi dari risiko kerusakan perangkat keras, virus, atau kebakaran toko fisik.",
        },
        {
          q: "Bagaimana cara memindahkan data stok dari pembukuan manual atau Excel lama kami?",
          a: "Kami menyediakan template import data Excel yang sangat mudah diisi. Selain itu, tim teknis AstaEnterprise siap mendampingi dan membantu memformat data stok awal Anda (nama perhiasan, kadar, berat, harga beli) hingga siap pakai tanpa biaya tambahan.",
        },
        {
          q: "Apakah sistem ini mendukung printer barcode thermal perhiasan dan scanner yang sudah kami miliki?",
          a: "Ya! AstaEnterprise kompatibel dengan printer label thermal standar (seperti Xprinter, Zebra, Postek, TSC dengan ukuran tag perhiasan 40x30mm atau label ekor) dan semua jenis barcode scanner USB maupun nirkabel (wireless).",
        },
        {
          q: "Bagaimana jika koneksi internet di toko tiba-tiba lambat atau terputus?",
          a: "AstaEnterprise dirancang ringan dan hemat kuota data sehingga dapat beroperasi lancar bahkan dengan koneksi tethering ponsel 4G. Untuk operasional kasir, sistem dilengkapi penyimpanan cache lokal sementara sehingga proses cetak nota tetap lancar.",
        },
        {
          q: "Apakah pemilik toko (Owner) bisa memantau omset dari rumah atau luar kota?",
          a: "Tentu saja. Karena berbasis web cloud modern, Anda dapat mengakses dashboard Owner kapan saja dan di mana saja melalui laptop, tablet, maupun smartphone secara real-time.",
        },
        {
          q: "Apakah staf kasir kami yang belum terbiasa komputer akan mudah menggunakannya?",
          a: "Antarmuka AstaEnterprise dirancang sangat intuitif dengan alur kasir sederhana dalam Bahasa Indonesia. Rata-rata staf kasir dapat menguasai sistem hanya dalam 1-2 sesi simulasi. Kami juga menyediakan panduan video lengkap dan tim support WhatsApp siap membantu setiap hari.",
        },
      ],
    },
    footer: {
      brandDesc: "Platform teknologi dan sistem manajemen bisnis toko emas modern. Solusi terintegrasi untuk POS kasir, inventaris kadar emas, cetak label barcode, hingga laporan keuangan multi-cabang.",
      locations: "Jakarta & Surabaya, Indonesia",
      email: "hello@astaenterprise.id",
      whatsapp: "+62 851-8300-3076 (Konsultasi WhatsApp)",
      instagram: "@astaenterprise.id",
      instagramUrl: "https://www.instagram.com/astaenterprise.id",
      modulesTitle: "Modul ERP Emas",
      ecosystemTitle: "Ekosistem Bisnis",
      securityTitle: "Keamanan & Keandalan",
      securityBadge1: "Enkripsi Data Bank-Grade",
      securityBadge1Desc: "Semua data transaksi dienkripsi SSL 256-bit",
      securityBadge2: "Daily Automated Backup",
      securityBadge2Desc: "Backup harian otomatis untuk cegah kehilangan data",
      securityBadge3: "Audit Trail Keamanan",
      securityBadge3Desc: "Rekam jejak setiap mutasi, kasir, dan harga",
      copyright: "AstaEnterprise (astaenterprise.id). All rights reserved. Platform Teknologi & Manajemen Bisnis Toko Emas Indonesia.",
      helpFaq: "Bantuan & FAQ",
      contactSupport: "Hubungi Support",
    },
    whatsapp: {
      tooltip: "Konsultasi Toko Emas via WhatsApp",
      prefill: "Halo AstaEnterprise, saya ingin konsultasi dan request demo software toko emas & perhiasan.",
    },
  },

  en: {
    meta: {
      title: "Best Gold & Jewelry Store ERP & POS Software | AstaEnterprise",
      description: "Modern gold & jewelry store ERP and POS software. Manage karat-based inventory, buybacks, barcode tags, and digital scale integrations. Try free demo.",
      keywords: "gold store ERP software, jewelry store POS software Indonesia, jewelry shop inventory system, gold shop software, jewelry barcode tags, gold buyback software, jewelry pos",
    },
    nav: {
      features: "Features",
      howItWorks: "How It Works",
      gallery: "Module Gallery",
      pricing: "Pricing",
      faq: "FAQ",
      ecosystem: "Ecosystem",
      whatsapp: "WhatsApp",
      requestDemo: "Request Free Demo",
      erp: {
        title: "Gold ERP Software",
        desc: "Complete POS & inventory system",
      },
      academy: {
        title: "Gold Business Academy",
        desc: "Education & masterclasses for gold owners",
      },
      community: {
        title: "Gold Entrepreneurs Circle",
        desc: "Exclusive network for jewelry store founders",
      },
      contact: "Contact Us",
    },
    hero: {
      badge: "#1 Gold & Jewelry Store ERP & POS in Indonesia",
      titleStart: "Modern Business OS & POS for ",
      titleHighlight: "Gold & Jewelry Stores",
      subheadline: "Manage multi-karat inventory with decimal-gram accuracy, sync live gold rates across all registers, print barcode tags, and issue certified gold invoices in one unified platform.",
      ctaPrimary: "Try Free Demo",
      ctaSecondary: "WhatsApp Consultation",
      stats: {
        users: "200+ Active Stores",
        accuracy: "99.9% Gram Accuracy",
        sync: "1-Second Sync",
        startingPrice: "From Rp 499k/mo",
      },
    },
    painPoints: {
      title: "Real Challenges in Jewelry Store Management",
      subtitle: "Manual ledger books and fragmented spreadsheets waste hours, risk gram calculation errors, and invite internal shrinkage.",
      solutionTag: "Solution: Automated Cloud System",
      items: [
        {
          title: "Manual Bookkeeping Causes Weight Discrepancies",
          desc: "Tracking jewelry in spreadsheets leads to lost decimal points, mismatched karatages, and costly physical stock discrepancies at closing.",
        },
        {
          title: "Slow Adaptation to Gold Price Volatility",
          desc: "When global or Antam gold spot prices surge, cashiers struggle to manually recalculate retail and buyback prices across hundreds of items.",
        },
        {
          title: "Handwritten Invoices & Unscannable Tags",
          desc: "Long cashier queues form because certificates are handwritten without barcodes, creating fraud risks and unverified paper warranties.",
        },
        {
          title: "Inventory Shrinkage Without Audit Trails",
          desc: "Impossible to track which staff applied unauthorized discounts, altered base gold rates, or moved items between vault and display cases.",
        },
      ],
    },
    features: {
      title: "Engineered Specifically for Gold & Jewelry Retail",
      subtitle: "Built with deep domain expertise in karat purity, net/gross weights, spread margins, and warranty certificate standards.",
      items: [
        {
          id: "dashboard",
          badge: "Executive Dashboard",
          title: "Monitor Daily Revenue, Vault Gold Value, & Cash Flow in Real-Time",
          desc: "Gain total executive visibility over cash flow and physical gold weight across all branches without waiting for end-of-day manual tallies.",
          highlights: [
            "Automated daily, weekly, and monthly revenue analytics",
            "Live physical gold weight tracking across showcases and vaults",
            "24K spot price trends and real-time margin spread monitoring",
            "Instant tracking of daily buybacks and net cash balances",
          ],
          image: "/assets/screenshots/dashboard.webp",
          url: "app.astaenterprise.id/dashboard",
          imageBadge: "Real-time KPI",
        },
        {
          id: "inventory",
          badge: "Stock & Purity",
          title: "Precise Multi-Karat Stock Control Down to Decimal Grams",
          desc: "Manage thousands of fine jewelry pieces with detailed purity levels (6K, 16K, 17K, 18K, 22K, 24K), net/gross weights, photos, and physical locations.",
          highlights: [
            "Separate tracking of gross weight, net weight, and karat purity",
            "Fast location filtering (Main Showcase, Store Vault, Central Warehouse)",
            "Automated alerts when popular jewelry collections run low on stock",
            "Instant barcode and SKU search for rapid inventory audits",
          ],
          image: "/assets/screenshots/inventory.webp",
          url: "app.astaenterprise.id/inventori",
          imageBadge: "6K - 24K Karats",
        },
        {
          id: "gold-price",
          badge: "Batch Price Updater",
          title: "1-Click Base Price Updates, Automatically Adjusting All Display Items",
          desc: "When market prices fluctuate, never waste time retagging items individually. The system instantly recalculates retail and buyback prices across all POS registers.",
          highlights: [
            "Centralized retail & buyback price formula configuration per karat",
            "Automated margin & spread calculator adapting to market swings",
            "1-second synchronization to all cashier registers and branch stores",
            "Prevents margin loss from staff selling at yesterday's outdated gold rates",
          ],
          image: "/assets/screenshots/gold-price.webp",
          url: "app.astaenterprise.id/harga-emas",
          imageBadge: "1-Click Sync",
        },
        {
          id: "pos",
          badge: "Cashier POS",
          title: "Fast, Flawless Checkout with Barcode Tag Scanners",
          desc: "Simply scan the jewelry barcode tag; the POS instantly calculates total pricing based on live karat rates, net gram weight, making charges, and discounts.",
          highlights: [
            "Seamless jewelry barcode scanner integration eliminates manual typos",
            "Automated formula calculations remove the need for desk calculators",
            "Supports multi-payment: Cash, QRIS, Bank Transfer, & Credit/Debit EDC",
            "Instant printing of official QR-coded gold certificates upon checkout",
          ],
          image: "/assets/screenshots/pos.webp",
          url: "app.astaenterprise.id/pos",
          imageBadge: "Barcode Ready",
        },
      ],
    },
    howItWorks: {
      title: "4 Easy Steps to Modernize Your Jewelry Store",
      subtitle: "Our specialist onboarding team assists you from Excel data migration to going live on the cashier floor.",
      steps: [
        {
          num: "01",
          title: "Setup Store Profile & Branches",
          desc: "Configure your store identity, branch locations, official certificate formatting, logo, and karatage pricing margins.",
        },
        {
          num: "02",
          title: "Import Inventory & Print Barcodes",
          desc: "Easily import existing stock from Excel spreadsheets, then print standard 40x30mm thermal jewelry barbell/tail tags.",
        },
        {
          num: "03",
          title: "Sync Daily Gold Spot Rates",
          desc: "Set base gold prices per karat. All showcase items and cashiers update simultaneously in under 1 second.",
        },
        {
          num: "04",
          title: "Start Selling & Monitor in Real-Time",
          desc: "Cashiers process transactions rapidly with barcode scanners, while owners monitor live revenue from any device.",
        },
      ],
    },
    gallery: {
      title: "Explore the Complete ERP Modules",
      subtitle: "Select a module below to inspect live screenshots of the AstaEnterprise interface.",
      ctaDemo: "Test This Module in Free Demo",
      liveBadge: "Live Capture",
      modules: [
        {
          id: "dashboard",
          title: "Executive Dashboard",
          badge: "Business Overview",
          image: "/assets/screenshots/dashboard.webp",
          url: "app.astaenterprise.id/dashboard",
          desc: "Track daily sales revenue, 24K gold market trends, active jewelry inventory weight, and cash flow in one executive view.",
          highlights: [
            "Automated daily, weekly, and monthly revenue charts",
            "Live physical gold weight tally in display cases and vaults",
            "Real-time monitoring of customer buybacks and net cash intake",
          ],
        },
        {
          id: "inventory",
          title: "Stock & Karat Purity",
          badge: "6K - 24K Purity",
          image: "/assets/screenshots/inventory.webp",
          url: "app.astaenterprise.id/inventori",
          desc: "High-precision jewelry cataloging with gross/net weight tracking, karat purity ratings, item photos, and showcase bin locations.",
          highlights: [
            "Clean separation of gross weight, net gold weight, & gemstones",
            "Categorization for Rings, Necklaces, Bracelets, Earrings, & Bullion",
            "Low-stock threshold alerts for popular jewelry designs",
          ],
        },
        {
          id: "pos",
          title: "POS & Barcode Scanner",
          badge: "Rapid Checkout",
          image: "/assets/screenshots/pos.webp",
          url: "app.astaenterprise.id/pos",
          desc: "Lightning-fast cashier checkout with barcode tag scanning. Automatically calculates craftsmanship charges, karatage, and split payments.",
          highlights: [
            "Scan jewelry barcode tags without manual data entry errors",
            "Instant calculation of promotional discounts, making fees, and taxes",
            "Supports Cash, QRIS, Bank Wire, and EDC card terminals",
          ],
        },
        {
          id: "gold-price",
          title: "Batch Gold Price Sync",
          badge: "1-Click Sync",
          image: "/assets/screenshots/gold-price.webp",
          url: "app.astaenterprise.id/harga-emas",
          desc: "Update base gold rates in a single click. Retail and buyback rates sync across all branch registers in under 1 second.",
          highlights: [
            "Configure retail and buyback pricing per karat (6K - 24K)",
            "Automated margin spread formula adapting to spot market shifts",
            "Eliminate revenue loss from cashiers applying yesterday's prices",
          ],
        },
        {
          id: "buyback",
          title: "Gold Buyback Desk",
          badge: "Transparent Valuation",
          image: "/assets/screenshots/buyback.webp",
          url: "app.astaenterprise.id/buyback",
          desc: "Process customer gold buybacks with legacy invoice verification and automated deduction calculations for shrinkage and stone weights.",
          highlights: [
            "Verify serial numbers and authenticity of legacy store receipts",
            "Automated deduction calculation for weight loss and gemstone weight",
            "Print official buyback receipts and maintain customer trade history",
          ],
        },
        {
          id: "reports",
          title: "Financial & Gram Ledgers",
          badge: "P&L and Stock Ledgers",
          image: "/assets/screenshots/reports.webp",
          url: "app.astaenterprise.id/laporan",
          desc: "Comprehensive financial intelligence from gross margins and daily cashier reconciliations to physical gold weight mutation ledgers.",
          highlights: [
            "Physical gold gram mutation ledger (inflow, outflow, balance)",
            "Gross profit margin and sales performance breakdown per cashier",
            "1-click export to audit-ready Excel spreadsheets and PDF reports",
          ],
        },
        {
          id: "multi-branch",
          title: "Multi-Store Hub",
          badge: "Centralized HQ",
          image: "/assets/screenshots/multi-branch.webp",
          url: "app.astaenterprise.id/multi-cabang",
          desc: "Oversee multi-branch gold store networks and manage inter-branch stock transfers with delivery waybill tracking from one portal.",
          highlights: [
            "Revenue and sales volume comparison across store locations",
            "Inter-store stock transfers with digital transit waybills",
            "Consolidated multi-branch financial accounting",
          ],
        },
        {
          id: "employees",
          title: "Roles & Security Audit",
          badge: "Audit Trail",
          image: "/assets/screenshots/employees.webp",
          url: "app.astaenterprise.id/karyawan",
          desc: "Enforce role-based access permissions (Owner, Manager, Cashier, Inventory) and maintain a tamper-proof activity audit log.",
          highlights: [
            "Cashiers cannot alter gold prices or discounts without supervisor authorization",
            "Comprehensive audit log tracks every price adjustment and stock mutation",
            "Maximum security against internal employee theft and shrinkage",
          ],
        },
      ],
    },
    testimonials: {
      title: "Trusted by 200+ Gold Stores & Jewelers",
      subtitle: "Hear how gold store founders transformed their operational efficiency and bottom-line profit with AstaEnterprise.",
      items: [
        {
          quote: "Recalculating thousands of jewelry tags whenever gold prices surged used to take our staff hours. With AstaEnterprise, updating base rates takes 1 minute and synchronizes 3 branches instantly. Our daily closing gram ledger balances 100%.",
          name: "H. Hendra Wijaya",
          role: "Owner, Toko Mas Sejahtera",
          location: "Surabaya (3 Stores)",
          avatar: "HW",
        },
        {
          quote: "The QR-coded gold certificates and thermal jewelry barcode tags look remarkably professional. Our customers have higher confidence, and cashiers never make weight or karat input mistakes anymore.",
          name: "Mrs. Ratna Dewi",
          role: "Owner, Dewi Jewelry Gallery",
          location: "Bandung",
          avatar: "RD",
        },
        {
          quote: "As a jewelry manufacturer who also operates retail stores, inventory control from raw gold melt to finished showroom pieces is vital. AstaEnterprise gives us total visibility over 12,000+ grams of circulating stock.",
          name: "Mr. Agus Salim",
          role: "Founder, Berkah Mulia Gold",
          location: "Yogyakarta",
          avatar: "AS",
        },
      ],
    },
    pricing: {
      title: "Transparent Plans for Every Jewelry Retailer",
      subtitle: "No hidden charges. Includes automated daily cloud backups and all future system software updates.",
      periodMonth: "/ month",
      popularBadge: "Most Popular",
      tiers: [
        {
          name: "Starter",
          tagline: "Ideal for independent gold stores transitioning to digital POS and inventory control.",
          price: "Rp 499,000",
          period: "/ month",
          featured: false,
          features: [
            "1 Gold Store Location",
            "Up to 3 Cashier & Staff Accounts",
            "POS Register & Barcode Tag Scanner",
            "Multi-Karat Inventory Control (6K - 24K)",
            "Batch Gold Rate Updater",
            "Thermal Jewelry Label & Certificate Printing",
            "Daily Sales & Revenue Reports",
            "WhatsApp Support & Video Tutorials",
          ],
          ctaText: "Choose Starter Plan",
        },
        {
          name: "Professional",
          tagline: "Most popular for growing jewelry retailers with multiple cashiers and high transaction volumes.",
          price: "Rp 1,199,000",
          period: "/ month",
          featured: true,
          badge: "Most Popular",
          features: [
            "Up to 3 Store Locations",
            "Unlimited Cashier & Staff Accounts",
            "All Starter Plan Features Included",
            "Transparent Customer Buyback Desk",
            "Physical Gold Gram Mutation & P&L Ledgers",
            "Complete Security Audit Trail & Activity Logs",
            "Inter-Branch Stock Transfer with Waybills",
            "Complimentary Excel Data Migration by Experts",
            "7-Day Priority Customer Support",
          ],
          ctaText: "Start Free Trial",
        },
        {
          name: "Enterprise",
          tagline: "Complete multi-branch business operating system for jewelry store chains, manufacturers, and distributors.",
          price: "Custom",
          period: "",
          featured: false,
          features: [
            "Unlimited Store Locations & Central Warehouses",
            "Unlimited Accounts & Multi-Level Permissions",
            "Precision Digital Scale Hardware Integration",
            "Custom-Branded QR Gold Certificate Templates",
            "Dedicated Cloud Database Server Instance",
            "Onsite Staff Training & Setup Assistance",
            "Dedicated Account Manager 24/7",
            "99.9% Guaranteed Uptime SLA",
          ],
          ctaText: "Contact Sales",
        },
      ],
      banner: {
        badge: "Schedule a Live Demo & Consultation",
        title: "Ready to Accelerate Growth and Eliminate Inventory Errors?",
        desc: "Consult with our gold retail specialists. We will demonstrate the software live and guide you through seamless data migration.",
        cta: "Chat on WhatsApp with Specialists",
        sub: "Fast response during business hours",
      },
    },
    faq: {
      title: "Frequently Asked Questions",
      subtitle: "Everything you need to know regarding cloud security, data migration, and hardware compatibility.",
      items: [
        {
          q: "Is my gold store's inventory and sales data secure in the cloud?",
          a: "Extremely secure. AstaEnterprise utilizes 256-bit bank-grade SSL encryption on ISO-certified cloud infrastructure. Automated daily backups ensure your inventory data and gold valuation are protected against hardware failures, ransomware, or physical store disasters.",
        },
        {
          q: "How do we migrate our existing stock data from manual ledgers or Excel?",
          a: "We provide an easy-to-fill Excel import template. Furthermore, our dedicated technical onboarding team will help format and import your initial catalog (item names, karats, weights, cost prices) free of charge.",
        },
        {
          q: "Is the system compatible with our existing jewelry thermal printers and barcode scanners?",
          a: "Yes! AstaEnterprise works out of the box with standard thermal label printers (such as Xprinter, Zebra, Postek, and TSC using standard 40x30mm jewelry barbell tags) as well as all USB and wireless barcode scanners.",
        },
        {
          q: "What happens if our store's internet connection slows down or drops?",
          a: "AstaEnterprise is optimized to be ultra-lightweight and operates smoothly even on a 4G smartphone mobile hotspot. For checkout registers, local temporary caching ensures cashier invoice generation and receipt printing remain uninterrupted.",
        },
        {
          q: "Can store owners monitor revenue and stock while away from the store?",
          a: "Absolutely. As a modern cloud-native web platform, you can access your Owner Dashboard at any time from any laptop, tablet, or smartphone in real time.",
        },
        {
          q: "Is the software easy to learn for cashiers who are not tech-savvy?",
          a: "The interface is engineered to be intuitive with streamlined cashier workflows in plain language. Most store staff master daily sales and tag scanning within 1–2 practice sessions. We also provide step-by-step video guides and daily WhatsApp customer support.",
        },
      ],
    },
    footer: {
      brandDesc: "Modern technology platform and business operating system for gold and jewelry retailers. Integrated POS, karat inventory, barcode labeling, and multi-branch accounting.",
      locations: "Jakarta & Surabaya, Indonesia",
      email: "hello@astaenterprise.id",
      whatsapp: "+62 851-8300-3076 (WhatsApp Consultation)",
      instagram: "@astaenterprise.id",
      instagramUrl: "https://www.instagram.com/astaenterprise.id",
      modulesTitle: "Gold ERP Modules",
      ecosystemTitle: "Business Ecosystem",
      securityTitle: "Security & Trust",
      securityBadge1: "Bank-Grade Encryption",
      securityBadge1Desc: "256-bit SSL encryption protects all transaction data",
      securityBadge2: "Daily Automated Backups",
      securityBadge2Desc: "Automated daily cloud backups prevent data loss",
      securityBadge3: "Security Audit Trail",
      securityBadge3Desc: "Tamper-proof logs for price edits, cashiers, and stock",
      copyright: "AstaEnterprise (astaenterprise.id). All rights reserved. Indonesia's Leading Gold & Jewelry Store Business Platform.",
      helpFaq: "Help & FAQ",
      contactSupport: "Contact Support",
    },
    whatsapp: {
      tooltip: "Gold Store Consultation via WhatsApp",
      prefill: "Hello AstaEnterprise, I would like to consult and request a demo for the gold & jewelry store software.",
    },
  },
};

export default translations;
